// src/utils/tesisat/sceneHelpers.js
//
// Tesisat rebuild icin sahne traverse ve cleanup yardimci fonksiyonlari.
// Saf fonksiyonlar — React/Redux bagimliligi yok.

/**
 * Sahnede belirli id'ye sahip ilk objeyi bul.
 */
export function findInScene(scene, id) {
  let found = null;
  scene.traverse(obj => {
    if (!found && obj.userData?.id === id) found = obj;
  });
  return found;
}

/**
 * Tesisat anchor world pozisyonu hesapla.
 * Entity'nin guncel world pozisyonuna offset ekler.
 */
export function computeAnchoredWorld(scene, item) {
  if (!scene || !item?.anchor?.entityId) return null;
  const entity = findInScene(scene, item.anchor.entityId);
  if (!entity) return null;
  entity.updateMatrixWorld(true);
  const m = entity.matrixWorld.elements;
  if (!Number.isFinite(m[12]) || !Number.isFinite(m[13])) return null;
  return {
    x: m[12] + (item.anchor.offset?.x || 0),
    y: m[13] + (item.anchor.offset?.y || 0),
    z: item.position?.z ?? 0,
  };
}

/**
 * Kat Plani documentGroup'u floorPlanId'ye gore bul.
 * Tesisat mesh'lerini (type/kind tasiyanlari) atlar.
 */
export function findFloorPlanGroup(scene, floorPlanId) {
  if (!scene || !floorPlanId) return null;
  let found = null;
  scene.traverse(o => {
    if (found) return;
    const ud = o.userData;
    if (!ud || ud.floorPlanId !== floorPlanId) return;
    if (ud.type || ud.kind) return;
    if (ud.docName === 'Kat Planı') found = o;
  });
  return found;
}

/**
 * Mesh ve tum children'in geometry/material'ini dispose edip parent'tan cikar.
 */
export function disposeMesh(obj) {
  if (!obj) return;
  obj.traverse?.(child => {
    if (child.geometry) child.geometry.dispose();
    if (child.material) {
      if (Array.isArray(child.material)) child.material.forEach(m => m.dispose());
      else child.material.dispose();
    }
  });
  if (obj.parent) obj.parent.remove(obj);
}
